import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsRootsComponent } from './simple-icons-roots.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsRootsComponent ],
    exports:      [ SimpleIconsRootsComponent ],
    bootstrap:    []
})
export class SimpleIconsRootsModule {}
